import { render, staticRenderFns } from "./ContactFormPage.vue?vue&type=template&id=0d6fb573&scoped=true"
import script from "./ContactFormPage.vue?vue&type=script&lang=js"
export * from "./ContactFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6fb573",
  null
  
)

export default component.exports